export default {
  seriesCnt: '6',
  backgroundColor: 'rgba(255,255,255,0)',
  titleColor: '#455a74',
  subtitleColor: '#7b93a7',
  textColorShow: false,
  textColor: '#333',
  markTextColor: '#ffffff',
  color: [
    '#6e81f5',
    '#83c9fc',
    '#96e036',
    '#ffe141',
    '#c193de',
    '#82d1c8',
    '#64d46f',
    '#ffacde',
    '#96e036'
  ],
  borderColor: '#ffffff',
  borderWidth: 0,
  visualMapColor: ['#008bc7', '#7d8fff', '#fcc2f9', '#fdf38b'],
  legendTextColor: '#455a74',
  kColor: '#7d8fff',
  kColor0: 'transparent',
  kBorderColor: '#7d8fff',
  kBorderColor0: '#6ee1eb',
  kBorderWidth: '1',
  lineWidth: '2',
  symbolSize: '6',
  symbol: 'emptyCircle',
  symbolBorderWidth: '2',
  lineSmooth: false,
  graphLineWidth: '1',
  graphLineColor: '#cccccc',
  mapLabelColor: '#455a74',
  mapLabelColorE: 'rgb(69,90,116)',
  mapBorderColor: '#d8dfe5',
  mapBorderColorE: '#7d8fff',
  mapBorderWidth: 0.5,
  mapBorderWidthE: 1,
  mapAreaColor: '#f1f4f6',
  mapAreaColorE: 'rgba(125,143,255,0.41)',
  axes: [
    {
      type: 'all',
      name: '通用坐标轴',
      axisLineShow: true,
      axisLineColor: '#c3ced7',
      axisTickShow: false,
      axisTickColor: '#333',
      axisLabelShow: true,
      axisLabelColor: '#c3ced7',
      splitLineShow: true,
      splitLineColor: ['#f1f4f6'],
      splitAreaShow: false,
      splitAreaColor: ['rgba(250,250,250,0.05)', 'rgba(200,200,200,0.02)']
    },
    {
      type: 'category',
      name: '类目坐标轴',
      axisLineShow: true,
      axisLineColor: '#333',
      axisTickShow: true,
      axisTickColor: '#333',
      axisLabelShow: true,
      axisLabelColor: '#333',
      splitLineShow: false,
      splitLineColor: ['#ccc'],
      splitAreaShow: false,
      splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)']
    },
    {
      type: 'value',
      name: '数值坐标轴',
      axisLineShow: true,
      axisLineColor: '#333',
      axisTickShow: true,
      axisTickColor: '#333',
      axisLabelShow: true,
      axisLabelColor: '#333',
      splitLineShow: true,
      splitLineColor: ['#ccc'],
      splitAreaShow: false,
      splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)']
    },
    {
      type: 'log',
      name: '对数坐标轴',
      axisLineShow: true,
      axisLineColor: '#333',
      axisTickShow: true,
      axisTickColor: '#333',
      axisLabelShow: true,
      axisLabelColor: '#333',
      splitLineShow: true,
      splitLineColor: ['#ccc'],
      splitAreaShow: false,
      splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)']
    },
    {
      type: 'time',
      name: '时间坐标轴',
      axisLineShow: true,
      axisLineColor: '#333',
      axisTickShow: true,
      axisTickColor: '#333',
      axisLabelShow: true,
      axisLabelColor: '#333',
      splitLineShow: true,
      splitLineColor: ['#ccc'],
      splitAreaShow: false,
      splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)']
    }
  ],
  axisSeperateSetting: false,
  toolboxColor: '#7b93a7',
  toolboxEmpasisColor: '#455a74',
  tooltipAxisColor: '#e7ebef',
  tooltipAxisWidth: 1,
  timelineLineColor: '#7d8fff',
  timelineLineWidth: '1',
  timelineItemColor: '#7d8fff',
  timelineItemColorE: '#7d8fff',
  timelineCheckColor: '#7d8fff',
  timelineCheckBorderColor: 'rgba(125,143,255,0.43)',
  timelineItemBorderWidth: 1,
  timelineControlColor: '#7d8fff',
  timelineControlBorderColor: '#7d8fff',
  timelineControlBorderWidth: 0.5,
  timelineLabelColor: '#7b93a7',
  datazoomBackgroundColor: 'rgba(255,255,255,0)',
  datazoomDataColor: 'rgba(222,222,222,1)',
  datazoomFillColor: 'rgba(125,143,255,0.36)',
  datazoomHandleColor: '#7d8fff',
  datazoomHandleWidth: '90',
  datazoomLabelColor: '#455a74'
}



// WEBPACK FOOTER //
// ./src/components/charts/theme-wonderland.js